import React, { useState, useEffect } from 'react';
import { IdleTimerProvider } from 'react-idle-timer';
import { useDispatch } from 'react-redux';
import { setHours } from '../../Redux/Slice/authSlice';
import { userLogTimeUpdateAction } from '../../Redux/Action/authAction';

const ShowTimer = ({ hours, userDate }) => {
  const dispatch = useDispatch();
  const [seconds, setSeconds] = useState(hours);
  const [isActive, setIsActive] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsLoggedIn(true); // Set isLoggedIn based on token presence
    } else {
      setIsLoggedIn(false); // Set isLoggedIn to false if no token found
    }
  }, []);

  useEffect(() => {
    let interval = null;

    if (isLoggedIn && isActive) {
      interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds + 1);
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isActive, isLoggedIn]);

  useEffect(() => {
    if (!isLoggedIn) return;
    dispatch(setHours(seconds));
  }, [seconds, isLoggedIn, dispatch]);

  useEffect(() => {
    if (typeof hours === 'number' && hours !== seconds) {
      setSeconds(hours);
    }
  }, [hours, seconds]);

  const onIdle = () => {
    const currentTime = new Date();
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const currentDayName = daysOfWeek[currentTime.getDay()];


    activeStatus(currentDayName);
    setIsActive(false);
  };

  const onActive = () => {
    setIsActive(true);
  };

  const activeStatus = async (currentDayName) => {
    try {
      const Payload = {
        date: new Date(),
        hours: seconds,
        id: userDate?.activityId,
        day:currentDayName
      };
      const response = await dispatch(userLogTimeUpdateAction(Payload));
      if (response?.payload?.statusCode === 200) {
      }
    } catch (error) {
      console.error('Error fetching initial time:', error);
    }
  };

  if (!isLoggedIn) {
    return null; // Return null if not logged in (no token)
  }

  return (
    <IdleTimerProvider
      timeout={1000 * 60 * 1} // 1 minute
      onIdle={onIdle}
      onActive={onActive}
    >
      <div>
        
      </div>
    </IdleTimerProvider>
  );
};

export default ShowTimer;

